<template>
  <div class="shelves-log">
    <Search ref="search" @search="search"/>
    <Table :list="logList"/>
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import Search from './components/search.vue';
import Table from './components/table.vue';
import BulkShelvesResults from '@/components/prod/center/dialogs/bulkShelvesResults.vue'

import {getOperatorLog} from "@/servers/prod/log"
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Search,
    Table,
    BulkShelvesResults
  },
  data() {
    return {
      logList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    ...mapActions(['fetch_channelByType']),
    search() {
      this.pagination.pageNo = 1;
      this.fetch_operatorLog();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_operatorLog();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_operatorLog();
    },
    async fetch_operatorLog() {
      const searchParams = this.$refs.search.method_getSearchForm();
      const {pageNo, pageSize} = this.pagination;
      const _params = {
        ...searchParams,
        operationType: 2,
        pageNo,
        pageSize
      }
      const res = await getOperatorLog(_params);
      if(!res) return;
      const {records, total} = res;
      this.logList = records;
      this.pagination.total = total;
    }
  },
  mounted() {
    this.search();
    this.fetch_channelByType({
      type: 2
    })
  },

}
</script>

<style lang="scss" scoped>

</style>
